import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { IntlReducer as Intl } from 'react-redux-multilingual';
import globalReducer from '../reducers/global-reducer'
import SignUpReducer from '../reducers/SignUpReducer'

// middleware: getDefaultMiddleware =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }),

export const store = configureStore({
  reducer: {
    Intl,
    globalreducer: globalReducer,
    signup: SignUpReducer,
  },
  middleware: getDefaultMiddleware => 
    getDefaultMiddleware({
      serializableCheck: false
    })

})